var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.test}},[_vm._v("测试btn")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }